import { baseApi, useDeleteIntegrationMutation } from 'src/services';
import { useEffect } from 'react';
import { useNotification } from 'src/hooks/useNotification';
import { useLoader } from 'src/provider/LoaderProvider';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CurrentZendeskChatIntegration } from 'src/pages/ControlDeskPage/IntegrationStatusSection/CurrentIntegrationField/CurrentIntegration/CurrentZendeskChatIntegration/CurrentZendeskChatIntegration';
import { CurrentZendeskEmailIntegration } from 'src/pages/ControlDeskPage/IntegrationStatusSection/CurrentIntegrationField/CurrentIntegration/CurrentZendeskEmailIntegration/CurrentZendeskEmailIntegration';
import { CurrentZohoSalesIQIntegration } from 'src/pages/ControlDeskPage/IntegrationStatusSection/CurrentIntegrationField/CurrentIntegration/CurrentZohoSalesIQIntegration/CurrentZohoSalesIQIntegration';
import { CurrentZohoDeskIntegration } from 'src/pages/ControlDeskPage/IntegrationStatusSection/CurrentIntegrationField/CurrentIntegration/CurrentZohoDeskIntegration/CurrentZohoDeskIntegration';
import { setSelectedIntegration } from 'src/store/slices/integrationSlice';
import { CurrentFreshchatIntegration } from 'src/pages/ControlDeskPage/IntegrationStatusSection/CurrentIntegrationField/CurrentIntegration/CurrentFreshchatIntegration/CurrentFreshchatIntegration';
import { CurrentFreshdeskEmailIntegration } from 'src/pages/ControlDeskPage/IntegrationStatusSection/CurrentIntegrationField/CurrentIntegration/CurrentFreshdeskEmailIntegration/CurrentFreshdeskEmailIntegration';
import { clsx } from 'clsx';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { INTEGRATION_ACCESS_ROLES } from 'src/constants/roles';

export const CurrentIntegration = ({ integration, integrationTypes = [] }) => {
  const { id } = useParams();
  const notification = useNotification();
  const loader = useLoader();
  const dispatch = useDispatch();
  const integrationTypeConfig =
    integrationTypes.find(
      (integrationType) => integrationType.data.integration_type === integration.integration_type,
    ) || {};
  const [
    deleteIntegration,
    { isSuccess: isSuccessDeleteIntegration, isLoading: isLoadingDeleteIntegration },
  ] = useDeleteIntegrationMutation();
  const deleteIntegrationHandler = (integrationId) => {
    deleteIntegration({ projectId: id, integrationId }).then(() => {
      dispatch(baseApi.util.invalidateTags(['Projects']));
    });
  };
  const { data: userInfo } = useGetUsersMeQuery();
  const disabledByPermision = !INTEGRATION_ACCESS_ROLES.includes(userInfo?.role);

  useEffect(() => {
    if (isSuccessDeleteIntegration) {
      notification.success('Integration Deleted.');
      dispatch(setSelectedIntegration(null));
    }
  }, [isSuccessDeleteIntegration]);

  useEffect(() => {
    if (isLoadingDeleteIntegration) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isLoadingDeleteIntegration]);

  useEffect(() => {
    if (integration) {
      loader.hide();
    }
  }, [integration]);

  switch (integration.integration_type) {
    case 'zendesk_chat':
      return (
        <CurrentZendeskChatIntegration
          integrationTypeConfig={integrationTypeConfig}
          integration={integration}
          deleteIntegrationHandler={deleteIntegrationHandler}
          disabledByPermision={disabledByPermision}
        />
      );
    case 'zendesk_email':
      return (
        <CurrentZendeskEmailIntegration
          integrationTypeConfig={integrationTypeConfig}
          integration={integration}
          deleteIntegrationHandler={deleteIntegrationHandler}
          disabledByPermision={disabledByPermision}
        />
      );
    case 'zoho_salesiq':
      return (
        <CurrentZohoSalesIQIntegration
          integrationTypeConfig={integrationTypeConfig}
          integration={integration}
          deleteIntegrationHandler={deleteIntegrationHandler}
          disabledByPermision={disabledByPermision}
        />
      );
    case 'zoho_desk':
      return (
        <CurrentZohoDeskIntegration
          integrationTypeConfig={integrationTypeConfig}
          integration={integration}
          deleteIntegrationHandler={deleteIntegrationHandler}
          disabledByPermision={disabledByPermision}
        />
      );
    case 'freshdesk_email':
      return (
        <CurrentFreshdeskEmailIntegration
          integrationTypeConfig={integrationTypeConfig}
          integration={integration}
          deleteIntegrationHandler={deleteIntegrationHandler}
          disabledByPermision={disabledByPermision}
        />
      );
    case 'freshdesk_chat':
      return (
        <CurrentFreshchatIntegration
          integrationTypeConfig={integrationTypeConfig}
          integration={integration}
          deleteIntegrationHandler={deleteIntegrationHandler}
          disabledByPermision={disabledByPermision}
        />
      );
  }
};
